export default __webpack_public_path__ + "static/bg-subbanner-3cd55d0ec507261ae6da7f22e0febd2d.webp";